// JWT Token Management Utilities
import { jwtDecode } from 'jwt-decode';


export interface JWTPayload {
  // Standard JWT fields
  sub?: string; // User ID (standard)
  id?: string; // Alternative user ID
  userId?: string; // Alternative user ID
  user_id?: string; // Alternative user ID

  // User information fields
  email?: string; // Standard email
  mail?: string; // Alternative email
  userEmail?: string; // Alternative email

  username?: string; // Standard username
  name?: string; // Alternative username
  userName?: string; // Alternative username
  user_name?: string; // Alternative username

  role?: string; // Standard role
  userRole?: string; // Alternative role
  user_role?: string; // Alternative role
  roles?: string[]; // Array of roles

  // Standard JWT fields
  iat: number; // Issued at
  exp: number; // Expiration
  jti?: string; // JWT ID

  // Additional fields that might be present
  [key: string]: any; // Allow additional fields
}

export interface TokenPair {
  accessToken: string;
  refreshToken: string;
}

class JWTManager {
  // Decode JWT token
  static decodeToken(token: string): JWTPayload | null {
    try {
      return jwtDecode<JWTPayload>(token);
    } catch (error) {
      console.error('Failed to decode token:', error);
      return null;
    }
  }

  // Check if token is expired
  static isTokenExpired(token: string): boolean {
    try {
      const decoded = this.decodeToken(token);
      if (!decoded) return true;

      const currentTime = Date.now() / 1000;
      return decoded.exp < currentTime;
    } catch (error) {
      console.error('Failed to check token expiration:', error);
      return true;
    }
  }
  // Use this for all API requests when receiving 401 status
}

// Global 401 Unauthorized handler - clears auth data and redirects to login
// Use this for all API requests when receiving 401 status
export const handleUnauthorized = (source: string = 'API'): void => {
  console.log(`${source}: 401 Unauthorized - clearing tokens and redirecting to login`);
  localStorage.removeItem('userData');
  localStorage.removeItem('userPreferences');
  // Redirect to login page (using smartecodev prefix)
  window.location.href = `${process.env.PUBLIC_URL}/login`;
};

export default JWTManager; 